import React from 'react'
import Table from 'react-bootstrap/Table';
import Tab1 from './Tab1';
import { MdOutlineKeyboardArrowLeft } from "react-icons/md"
import { MdOutlineKeyboardArrowRight } from "react-icons/md"


function Schduletab() {

  return (<>
    <Table responsive className='table_schdule mt-2' style={{ background: "#fff", height: "30vh", overflowY: "scroll" }}>
      <tbody style={{ backgroundColor: "#fff" }}>
        <tr className='' style={{ borderTop: "1px solid rgb(212, 215, 218)", position: "relative" }} >
          {/* <MdOutlineKeyboardArrowLeft className='schedule_left_arrow' />
          <MdOutlineKeyboardArrowRight /> */}
          <td>
            <p className='schedule_day'>MON</p></td>
          <td>
            <p className='schedule_day'>TUE</p>
          </td>
          <td>
            <p className='schedule_day'>WED</p>

          </td>
          <td>
            <p className='schedule_day'>THU</p>
          </td>
          <td>
            <p className='schedule_day'>FRI</p>
          </td>
          <td>
            <p className='schedule_day'>SAT</p>
          </td>


        </tr>
        <tr></tr>
        <tr className='head_table ps-3' style={{ backgroundColor: "white" }} >

          <td>
            <Tab1 /></td>
          <td>
            <Tab1 />
          </td>
          <td>
            <Tab1 />

          </td>
          <td>
            <Tab1 />
          </td>
          <td>
            <Tab1 />
          </td>
          <td>
            <Tab1 />
          </td>



        </tr>




      </tbody>
    </Table>

  </>

  )
}

export default Schduletab